/**
 * Copyright (C) Siemens AG 2016-2025 ALL RIGHTS RESERVED.
 */
import {Component, OnInit, inject} from '@angular/core';
import {themeSwitcher} from '@siemens/ix';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../../../services/user.service';

@Component({
  selector: 'app-legal-disclaimer',
  standalone: false,
  templateUrl: './legal-disclaimer.component.html',
  styleUrl: './legal-disclaimer.component.scss',
})
export class LegalDisclaimerComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly userService = inject(UserService);

  protected readonly themeSwitcher = themeSwitcher;

  returnUrl = '/app';

  loading = false;

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const returnUrl = params['returnUrl'];

      if (returnUrl?.startsWith('/')) {
        this.returnUrl = returnUrl;
      }
    });
  }

  async onDisclaimerAccepted() {
    try {
      this.loading = true;
      await this.userService.acceptDisclaimer();
      await this.router.navigateByUrl(this.returnUrl);
      this.loading = false;
    } catch {
      this.loading = false;
    }
  }

  onDisclaimerDeclined() {
    return this.userService.logout();
  }
}
